<template>
  <Transition name="slide-from-right">
    <aside v-if="openSidebar" id="order-sidebar">
      <div>
        <OrderFunnelProgressSteps :step="progressStep" :total-steps="totalStepsForProgress"/>
        <div class="aside-order">
          <!-- keep v-show here for form submission -->
          <div class="wc-deposits-wrapper" v-show="step === 1">
            <div>Veuillez sélectionner votre mode de paiement :</div>
            <ul class="wc-deposits-option">
              <li>
                <input form="go2rouescart" type="radio" name="wc_deposit_option" value="no" v-model="depositOption"
                       id="wc-option-pay-full" checked/>
                <label for="wc-option-pay-full">Paiement comptant</label>
              </li>
              <template v-if="pledgIsAvailable">
                <li>
                  <input form="go2rouescart" type="radio" name="wc_deposit_option" value="pledg_4x"
                         data-paiement="pledg_4x"
                         id="pledg-4x" v-model="depositOption"/>
                  <label for="pledg-4x">Paiement en 4x</label>
                </li>
                <li>
                  <input form="go2rouescart" type="radio" name="wc_deposit_option" value="siko_12x"
                         data-paiement="siko_12x"
                         id="siko-12x" v-model="depositOption"/>
                  <label for="siko-12x">Paiement en 10x</label>
                </li>
              </template>
              <li v-if="loaIsAvailable && loaSlidersLoaded">
                <input form="go2rouescart" type="radio" name="wc_deposit_option" value="loa" id="g2r-loa"
                       v-model="depositOption"/>
                <label for="g2r-loa">Location <span>{{ priceFr(loaRecap.mensualite) }}</span> sur
                  <strong>{{ loaRecap.duree }} mois</strong> pour
                  <strong>{{ loaRecap.kmAn }} km/an</strong> (voir notre <a
                    href="/guide/location-avec-option-d-achat/"
                    target="_blank">guide
                    de la LOA</a>)</label>
              </li>
            </ul>
          </div>
          <div v-if="step === 2">
            <ChainedProducts/>
          </div>
          <div v-if="step === 3">
            <AccessoiresCompatibles/>
          </div>
          <div v-if="step === 4">
            <AdditionalServices/>
          </div>
          <div v-if="step === 5" style="text-align: center">
            <div><Spinner :size="36" /></div>
            Vous allez être redirigé vers le panier.
          </div>
          <!-- keep v-show otherwise buttons are seen as outside aside on last step -->
        </div>
      </div>
      <div class="deposit__steps" v-show="step < 5">
        <div class="deposit__prev">
          <button v-show="step > 1" type="button" class="button" @click="prev">
            &larr; <span>Précédent</span>
          </button>
        </div>
        <div class="deposit__next">
          <button type="button" class="button" @click="next">
            <span>Suivant</span> &rarr;
          </button>
        </div>
      </div>
    </aside>
  </Transition>
</template>

<script>
import AccessoiresCompatibles from "@/front/components/product/AccessoiresCompatibles";
import Truck from "@/components/icons/Truck";
import ChainedProducts from "@/front/components/product/ChainedProducts";
import OrderFunnelProgressSteps from "@/components/features/OrderFunnelProgressSteps.vue";
import {onKeyUp} from "@vueuse/core";
import SvgSpinner from "@/components/partials/SvgSpinner.vue";
import AdditionalServices from "@/components/features/AdditionalServices";
import Spinner from "@/components/icons/Spinner.vue";

export default {
  name: "ProductPageCommander",
  components: {
    ChainedProducts,
    Truck,
    AccessoiresCompatibles,
    OrderFunnelProgressSteps,
    SvgSpinner,
    AdditionalServices,
    Spinner,
  },
  data() {
    return {
      modalData: {},
      step: 1,
      progressStep: 1,
      depositOption: 'no',
      loaSlidersLoaded: false,
      loaRecap: {},
      openSidebar: false,
    }
  },
  computed: {
    loaIsAvailable() {
      const els = document.getElementsByTagName('loa-sliders')
      return els.length > 0
    },
    pledgIsAvailable() {
      const tr = document.querySelector('.financement .pledg__4x')
      return tr instanceof Node
    },
    g2rObj() {
      return window.g2rObj
    },
    hasCurrentChainedOffer() {
      return null !== document.querySelector('.chained__wrapper')
    },
    totalStepsForProgress() {
      if (this.hasCurrentChainedOffer) {
        return 5
      } else {
        return 4
      }
    },
  },
  watch: {
    openSidebar(val) {
      if (val) {
        this.disableScroll()
        const darkLayer = document.createElement('div');
        darkLayer.id = 'darklayer';
        document.querySelector('.site-container').after(darkLayer);
        setTimeout(() => darkLayer.classList.add('active'), 20);
        setTimeout(() => {
          document.body.addEventListener('click', this.bodyListener)
          document.addEventListener('touchstart', this.listenTouchStart)
          document.addEventListener('touchmove', this.listenTouchMove)
        }, 200)
      } else {
        this.enableScroll()
        const darkLayer = document.getElementById('darklayer');
        darkLayer.classList.remove('active');
        document.removeEventListener('touchstart', this.listenTouchStart)
        document.removeEventListener('touchmove', this.listenTouchMove)
        setTimeout(() => {
          darkLayer.remove()
          document.body.removeEventListener('click', this.bodyListener)
        }, 200);
      }
    }
  },
  methods: {
    listenTouchStart(e) {
      this.swipeX = e.touches[0].clientX
    },
    listenTouchMove(e) {
      let x = e.touches[0].clientX
      if (x - this.swipeX > 100) {
        this.openSidebar = false
      }
    },
    bodyListener(e) {
      if (e.target.id !== 'g2r-commander-button' && !this.hasOrderSidebarParent(e.target)) {
        this.openSidebar = false
      }
    },
    hasOrderSidebarParent(element) {
      if (!element) {
        // If we reach the root of the document without finding #devis-sidebar, return false
        return false;
      }
      if (element.id === 'order-sidebar') {
        // Found #devis-sidebar as an ancestor, return true
        return true;
      }
      // Recursively check the parent of the current element
      return this.hasOrderSidebarParent(element.parentElement);
    },
    disableScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      // if any scroll is attempted, set this to the previous value
      window.onscroll = function (e) {
        window.scrollTo({top: scrollTop, behavior: 'smooth'});
      };
    },
    enableScroll() {
      window.onscroll = function () {
      };
    },
    next() {
      if (this.step === 1) {
        if (this.hasCurrentChainedOffer) {
          this.step = this.step + 1;
        } else {
          this.step = this.step + 2;
        }
      } else if (this.step === 4) {
        this.step++
        document.querySelector('form#go2rouescart').submit();
      } else {
        this.step = this.step + 1
      }
      this.progressStep++
    },
    prev() {
      if (this.step === 3) {
        if (this.hasCurrentChainedOffer) {
          this.step = this.step - 1;
        } else {
          this.step = this.step - 2;
        }
      } else {
        this.step = this.step - 1
      }
      this.progressStep--
    },
    priceFr(val) {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
      }).format(val)
    },
    generateLoaRecap() {
      this.loaRecap = {
        mensualite: document.querySelector('[name="loa-mensualite"]').value,
        duree: document.querySelector('[name="loa-duree"]').value,
        kmAn: document.querySelector('[name="loa-km-an"]').value,
      }
    },
  },
  beforeMount() {
    this.modalData = JSON.parse(document.querySelector('#vue-data-product-page-commander').innerHTML)
    // Select the node that will be observed for mutations
    const targetNode = document.getElementById("go2rouescart");
    // Options for the observer (which mutations to observe)
    const config = {attributes: true, childList: true, subtree: true};
    // Callback function to execute when mutations are observed
    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === "childList") {
          const el = mutation.addedNodes.item(0);
          if (el && el.name === 'loa-duree') {
            this.loaSlidersLoaded = true
            // Set initial value on mobile
            this.generateLoaRecap()
          }
        }
        // set a value for product simple on load
        if (this.loaSlidersLoaded && document.body.classList.contains('simple')) {
          this.generateLoaRecap()
        }
        // for product variable listen to mutations
        if (this.loaSlidersLoaded && mutation.type === 'attributes') {
          if (mutation.target.tagName === 'INPUT' && mutation.attributeName === 'value') {
            this.generateLoaRecap()
          }
        }
      }
    }
    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);
    // Start observing the target node for configured mutations
    observer.observe(targetNode, config);
    // Later, you can stop observing
    //     observer.disconnect();
  },
  mounted() {
    const commanderButton = document.querySelector('#g2r-commander-button');
    if (commanderButton != null) {
      commanderButton.addEventListener('click', (e) => {
        if (!e.target.classList.contains('disabled')) {
          this.openSidebar = true
          this.depositOption = 'no'
        }
      });
    }
    const louerButton = document.querySelector('#g2r-louer-button');
    if (louerButton != null) {
      louerButton.addEventListener('click', (e) => {
        if (!e.target.classList.contains('disabled')) {
          this.openSidebar = true
          this.depositOption = 'loa'
        }
      });
    }
    onKeyUp('Escape', () => this.openSidebar = false)
  },
}
</script>

<style scoped lang="scss">
// Transition
$timing: .2s;
.slide-from-right-enter-active {
  animation: slide-from-right-base-opacity-fade $timing;
}

.slide-from-right-leave-active {
  animation: slide-from-right-base-opacity-fade reverse $timing;
}

@keyframes slide-from-right-base-opacity-fade {
  0% {
    transform: translateX(90vw);
  }
  100% {
    transform: translateX(0);
  }
}

aside {
  position: fixed;
  top: 0;
  right: 0;
  background-color: #fcfdff;
  padding: 2rem;
  height: 100%;
  width: 620px;
  max-width: 100vw;
  border-left: 2px solid var(--dark-blue);
  z-index: 100;
  overflow-y: scroll;
  accent-color: var(--dark-blue);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .wc-deposits-wrapper {
    margin-bottom: 2rem;

    .wc-deposits-option {

      li {
        padding: 1.5rem 2rem;
        border: 1px solid #ccc;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        box-sizing: border-box;
        margin: 1rem 0;
        display: grid;
        grid-template-columns: 25px auto;

        input {
          margin-top: 4px;
          margin-bottom: 0;
          $size: 15px;
          width: $size;
          height: $size;
        }

        label {
          cursor: pointer;
        }
      }
    }

  }

}


.aside-order {
  transition: width .15s;

  [for="overide-amount"] {
    margin-left: .5rem;
  }

  [type="number"] {
    width: 100px;
    height: 30px;
    margin-left: .5rem;
  }

  [for="g2r-loa"] {
    span {
      color: var(--yellow);
    }
  }

}

.deposit__steps {
  display: flex;
  justify-content: space-between;

  .deposit__next {
    button {
      background: var(--g2r-linear-gradient-1);
    }
  }

  .deposit__prev {
    button {
      background: var(--g2r-linear-gradient-1-rev);
    }
  }

  button {
    width: 60px;
    padding: 1rem;
    @media screen and (min-width: 768px) {
      width: 130px;
    }

    span {
      display: none;
      @media screen and (min-width: 768px) {
        display: inline;
      }
    }
  }
}
</style>

<style lang="scss">
#darklayer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all .2s;
  z-index: 99;

  &.active {
    background-color: rgba(0, 0, 0, .6);
  }
}
</style>
